<template>
	<div class="groupmenu">
		<WFScrollableArea ref="groupscroll">
			<div class="th-list text-20">
				<WFAZMenu v-if="!currentGroup">
					<template v-slot="slotProps" >
						<ListPOI :poi="slotProps.poi" @onPOIClick="onPOIClick" :class="{'wf-active': currentPOI && currentPOI.id == slotProps.poi.id}"></ListPOI>
					</template>
				</WFAZMenu>
				<WFSubGroupMenu v-if="currentGroup" :parent="currentGroup ? currentGroup.id : -1" :currentPOI="currentPOI" :showPOIs="true" :showPOILogo="true" :showPOIFloor="true">
					<template v-slot:poi="slotProps" >
						<ListPOI :poi="slotProps.poi" @onPOIClick="onPOIClick" :class="{'wf-active': currentPOI && currentPOI.id == slotProps.poi.id}"></ListPOI>
					</template>
				</WFSubGroupMenu>
			</div>
		</WFScrollableArea>
	</div>
</template>

<script>
	import { WFScrollableArea, WFSubGroupMenu } from '@3dwayfinder/wayfinder-vue-components'
	import ListPOI from './ListPOI.vue'

	import { mapState } from 'vuex';
	export default {
		components: {
			WFSubGroupMenu,
			WFScrollableArea,
			ListPOI
		},
		props: {
			currentGroup: {
				default: null,
				type: Object
			},
			currentPOI: {
				default: null,
				type: Object
			}
		},
		computed: {
			...mapState('wf', ['language']),
		},
		watch: {
			currentGroup() {
				this.$nextTick(() => {
					if(this.$refs.groupscroll) {
						this.$refs.groupscroll.resize();
						this.$refs.groupscroll.reset();
					}
				});
			},
		},
		methods: {
			onPOIClick (poi) {
				this.$emit('onPOIClick', poi);
			},
			getFirstGroup(poi) {
				if(typeof poi === "object") {
					return poi.getGroupNames().length > 0 ? poi.getGroupNames()[0] : '';
				}

				return "";
			}
		}
	}
</script>
  
<style lang="postcss">
	.groupmenu {
		height: 100%;
		overflow: hidden;
	}
	/* ===== 4K PORTRAIT ONLY - GroupMenu (POI List) ===== */
@media (orientation: portrait) and (min-width: 2160px) {
  .groupmenu .th-list {
    font-size: 4rem !important;
  }
  
  /* POI list items - 2x */
  .groupmenu .wf-poi-list-item,
  .groupmenu .wf-list-item {
    min-height: 14rem !important;
    padding: 3.2rem 2.4rem !important;
  }
  
  /* Store names (main text) - CORRECT SELECTOR - 2x */
  .groupmenu .wf-poi-list-item .leading-normal,
  .groupmenu .wf-poi-list-item .text-16 {
    font-size: 5.2rem !important; /* 26px * 2 = 52px = 5.2rem */
    line-height: 3 !important; /* 1.5 * 2 */
  }
  
  /* Floor indicators (small text on right) - 2x */
  .groupmenu .wf-poi-list-item .text-sm,
  .groupmenu .wf-poi-list-item small,
  .groupmenu .wf-poi-floor {
    font-size: 3.6rem !important;
  }
  
  /* Any other translatable text - 2x */
  .groupmenu .wf-translatable {
    font-size: 4.2rem !important;
  }
  
  /* Store info icons - 2x */
  .groupmenu .wf-poi-list-item .wf-icon,
  .groupmenu .wf-poi-list-item img:not(.wf-poi-logo) {
    width: 6.4rem !important;
    height: 6.4rem !important;
  }
}
  </style>